import React from "react";
import { AppWrap, MotionWrap } from "../../wrapper";
import { GiDiamonds } from "react-icons/gi";
import "./Experience.scss";

const TimelineEntry = ({ companyName, descriptions, tenure }) => (
  <div className="entry">
    <div className="flex mb-base">
      <div className="dot mt-s bg-color-primary"></div>
      <div className="flex flex-col gap-s">
        <div className="feature-accent color-primary-text">{companyName}</div>
        <div className="content neutral-700">{tenure}</div>
      </div>
    </div>
    <div className="description flex flex-col gap-sm">
      {descriptions.map((desc, index) => (
        <div className="flex flex-justify-center gap-s">
          <span>
            <GiDiamonds />
          </span>
          <span className="highlight neutral-1000" key={index}>
            {desc}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const Experience = () => {
  const experiences = [
    {
      companyName: "SDE II - Matrix Systems",
      tenure: "May, 2025 - Present",
      descriptions: [
        "Developed and enhanced critical modules for a large-scale wealth management and portfolio optimization platform, utilizing Angular, TypeScript, Java, and Oracle SQL to deliver enterprise-grade solutions processing millions of portfolio transactions for financial institutions.",
        "Built a full-stack PR Analytics Dashboard as an in-house monitoring tool, leveraging React, TypeScript, Node.js, Express, Prisma, and MySQL. The dashboard integrates with GitHub and Bitbucket via OAuth, processes PR data, and provides AI-powered insights using OpenAI's GPT-4o-mini, enabling engineering teams to track code quality metrics and collaboration patterns in real time.",
        "Redesigned and standardized UI components across the application, creating a unified design system that reduced component development time by 55% and ensured consistent user experience across 50+ application screens.",
        "Refactored legacy code modules, improving code maintainability and reducing technical debt. This optimization decreased bug reports by 45% and cut debugging time by 70%, significantly improving system reliability.",
      ],
    },
    {
      companyName: "Software Engineer - Techlogix ",
      tenure: "Jun, 2023 - Apr, 2025",
      descriptions: [
        "Built and enhanced a large-scale digital banking application, utilizing ReactJS, KnockoutJS, JavaScript, Java, Jenkins, and Oracle SQL to deliver a seamless experience for over 2 million users.",
        "Played a key role in developing critical modules such as Fund Transfer, Bill Payments, Mobile Top-ups, AMIM, RAAST, and Payoneer, contributing to revenue growth in the thousands for the company.",
        "Proactively refactored critical modules, optimizing code structure, enforcing best practices, and introducing reusable components. This significantly reduced bugs, cut debugging time by 80%, and improved both user experience and long-term scalability.",
        "Designed and developed key UI components while contributing to the implementation of a frontend design system with SCSS and mixins. This streamlined theme management, cut UI creation time by more than 50%, and ensured a consistent look and feel across the application.",
        "Led the development of a large-scale digital account opening application, mentoring two junior developers and leveraging ReactJS, JavaScript, and Clean Architecture. Focused on efficient data state management to ensure smooth performance and scalability.",
        "Authored comprehensive documentation outlining coding standards, team workflows, and best practices, which simplified the onboarding process, cut training time by 70%, and significantly improved team productivity.",
        "Developed batch scripts to automate the creation of components and UI elements, generating the necessary SQL scripts and template code. This automation streamlined the development process, reducing development time for the team. Additionally, created other batch scripts tailored to the team's specific needs.",
        "Received 'Achiever of the Month' recognition for excelling in onsite development while being part of a resource augmentation project, delivering seamless on-site support and effective solutions.",
      ],
    },
    {
      companyName: "Freelance Developer - Fiverr (Level 2 Seller)",
      tenure: "Jan, 2021 – Dec, 2023",
      descriptions: [
        "Completed 50+ orders with consistent 5-star ratings, helping clients worldwide with high-quality, reliable solutions tailored to their needs.",
        "Worked on a wide range of projects including small-scale Python applications, full-stack web development projects, DSA (Data Structures & Algorithms) problems, and custom web scrapers.",
        "Delivered efficient and maintainable code under tight deadlines, ensuring timely project completion and client satisfaction.",
        "Built reusable components and scripts to streamline future projects, reducing delivery time and increasing development efficiency.",
        "Maintained clear communication with clients to understand requirements and deliver solutions that aligned with their vision.",
        "Offered post-delivery support and documentation to ensure smooth deployment and usability of the developed solutions.",
      ],
    },
  ];
  

  return (
    <div className="flex flex-col gap-base">
      <h2 className="color-primary-text heading-1">
        The <span className="color-primary">Road</span> So Far
      </h2>
      <div className="timeline p-base flex flex-col gap-base">
        {experiences.map((entry, index) => (
          <TimelineEntry
            key={index}
            companyName={entry.companyName}
            descriptions={entry.descriptions}
            tenure={entry.tenure}
          />
        ))}
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Experience, "flex full-width flex-col"),
  "experience",
  "bg-color-base-bg"
);
